import { LayoutContainerProps } from 'components/Layout/atoms/LayoutContainer/LayoutContainer.types';
import classes from './LayoutContainer.module.css';

export const LayoutContainer = ({ children }: LayoutContainerProps) => (
  <div className={classes.layoutContainer}>{children}</div>
);
